import React, { useState } from 'react'
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router-dom'
import { ButtonCreate, LeftSide, RefreshIconContainer, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/styles/subheader-style'
import { RefreshCw } from 'lucide-react'
import { Content } from './style'

const TAB_INDEX_NF = 0
const TAB_INDEX_TAX = 1

const taxTabs = [
    { path: '/panel/invoice', name: 'Nota Fiscal', index: TAB_INDEX_NF },
    { path: '/panel/invoice/tax-scenario', name: 'Cenário Fiscal', index: TAB_INDEX_TAX }
]

const TaxModuleLayout: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [refresh, setRefresh] = useState(false)
    const [handleChildSubmit, setHandleChildSubmit] = useState<(() => void) | null>(null);
    
    // Verifica as rotas para mudar o SubHeader
    const isTaxScenario = !!useMatch('/panel/invoice/tax-scenario')
    const isCreatingScenario = !!useMatch('/panel/invoice/tax-scenario/create')
    const isCreatingInvoice = !!useMatch('/panel/invoice/create');
    const isEditingInvoice = !!useMatch('/panel/invoice/edit/:id');
    const isViewingInvoice = !!useMatch('/panel/invoice/view/:id');
    const isInvoiceDetail = isCreatingInvoice || isEditingInvoice || isViewingInvoice;
    
    const handleNewScenario = () => {
        navigate('/panel/invoice/tax-scenario/create')
    }

    return (
        <>
            <SubHeaderContainer>
                <LeftSide>
                    <SectionName>Fiscal</SectionName>
                    
                    {/* Abas sempre visíveis */}
                    <TabsDiv>
    {taxTabs.map((tab) => (
        <Tab
            key={tab.index}
            $isFirst={tab.index === 0}
            $isLast={tab.index === taxTabs.length - 1}
            $isActive={
                                location.pathname === tab.path ||
                                (tab.index === TAB_INDEX_NF && isInvoiceDetail) ||
                                (tab.index === TAB_INDEX_TAX && isCreatingScenario)
                            }
            onClick={() => navigate(tab.path)}
        >
            {tab.name}
        </Tab>
    ))}
</TabsDiv>
                </LeftSide>

                <RightSide>
                    {/* Atualizar — escondido só na criação de cenário */}
                    {!isCreatingScenario && (
                        <RefreshIconContainer
                            onClick={() => setRefresh((prev) => !prev)}
                            title='Atualizar'
                        >
                            <RefreshCw size={20} />
                        </RefreshIconContainer>
                    )}

                    {/* Lógica dos Botões de Ação */}
                    {isCreatingScenario ? (
                        <>
                            <ButtonCreate
                                onClick={() => navigate(-1)}
                                style={{ background: '#fff', color: '#0090D3', border: '1px solid #0090D3' }}
                            >
                                Cancelar
                            </ButtonCreate>
                            <ButtonCreate onClick={() => handleChildSubmit && handleChildSubmit()}>
                                Salvar Cenário
                            </ButtonCreate>
                        </>
                    ) : (
                        isTaxScenario && (
                            <ButtonCreate onClick={handleNewScenario}>+ Novo Cenário</ButtonCreate>
                        )
                    )}
                </RightSide>
            </SubHeaderContainer>

            <Content>
                <Outlet context={{ setHandleChildSubmit, refresh }} />
            </Content>
        </>
    )
}

export default TaxModuleLayout